import React, { useState, useRef } from 'react'
import { createUseStyles } from 'react-jss'
import _ from 'lodash'

import SVG from '../SVG/SVG'

const useStyles = createUseStyles(theme => ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        fontFamily: theme.fontFamily,
        backgroundColor: theme.colors.blue,
        borderTopLeftRadius: theme.borderRadius,
        borderTopRightRadius: theme.borderRadius,
        borderBottomLeftRadius: theme.borderRadius,
        borderBottomRightRadius: theme.borderRadius,
        marginBottom: '10px',

        '@media (max-width: 600px)': {
            marginBottom: '3px',
        },
    },

    accordion: {
        backgroundColor: theme.colors.blue,
        color: theme.colors.white,
        cursor: 'pointer',
        padding: '3px 39px 4px 39px',
        display: 'flex',
        alignItems: 'center',
        border: 'none',
        borderTopLeftRadius: theme.borderRadius,
        borderTopRightRadius: theme.borderRadius,
        borderBottomLeftRadius: theme.borderRadius,
        borderBottomRightRadius: theme.borderRadius,
        outline: 'none',
        transition: `background-color 250ms ${theme.animations.bezier}`,
        width: '100%',

        '@media (max-width: 600px)': {
            padding: '3px 14px 3px 14px',
        },
    },

    accordionActive: {
        backgroundColor: theme.colors.blue,
        color: theme.colors.white,
        cursor: 'pointer',
        padding: '3px 39px 0 39px',
        display: 'flex',
        alignItems: 'center',
        border: 'none',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderTopLeftRadius: theme.borderRadius,
        borderTopRightRadius: theme.borderRadius,
        outline: 'none',
        transition: `background-color 250ms ${theme.animations.bezier}`,
        width: '100%',

        '@media (max-width: 600px)': {
            padding: '3px 12px 3px 12px',
        },
    },

    title: {
        color: `${theme.colors.white} !important`,
        fontSize: `18px !important`,
        fontWeight: `500 !important`,
        lineHeight: '21px',
        textAlign: 'left',

        '@media (max-width: 600px)': {
            fontSize: `16px !important`,
            lineHeight: 'normal',
            letterSpacing: '0.44px',
            fontWeight: `400 !important`,
            marginTop: 7,
            marginBottom: 6,
        },
    },

    icon: {
        marginLeft: 'auto',
        '& svg': {
            transform: 'rotate(90deg)',
            transition: `transform 250ms ${theme.animations.bezier}`,
        },
    },

    iconActive: {
        marginLeft: 'auto',
        '& svg': {
            transform: 'rotate(-90deg)',
            transition: `transform 250ms ${theme.animations.bezier}`,
        },
    },

    content: {
        background: theme.colors.blue,
        border: 'none',
        borderBottomLeftRadius: theme.borderRadius,
        borderBottomRightRadius: theme.borderRadius,
        overflow: 'hidden',
        transition: `maxHeight 250ms ${theme.animations.bezier}`,
    },

    // title: {
    //     color: `${theme.colors.white} !important`,
    //     fontSize: `18px !important`,
    //     fontWeight: `500 !important`,
    //     lineHeight: '21px',
    //     textAlign: 'left',

    //     '@media (max-width: 600px)': {
    //         fontSize: `16px !important`,
    //         lineHeight: 'normal',
    //         letterSpacing: '0.44px',
    //         fontWeight: `400 !important`,
    //         marginTop: 7,
    //         marginBottom: 6,
    //     },
    // },

    text: {
        color: `${theme.colors.white} !important`,
        fontSize: `18px !important`,
        fontWeight: 300,
        lineHeight: '21px',
        padding: '0px 55px 17px 39px',

        '& p': {
            color: `${theme.colors.white} !important`,
            fontSize: `18px !important`,
            fontWeight: 300,
            lineHeight: '21px',
        },

        '& img': {
            maxWidth: '100%',
            height: 'auto',
        },

        '& a': {
            fontSize: 18,
            color: theme.colors.white,
            fontFamily: theme.fontFamily,
            fontWeight: `300 !important`,
            fontStyle: 'italic',
            letterSpacing: 0.2,
            textDecoration: 'underline',

            '&:hover': {
                color: theme.colors.yellow,
                textDecoration: 'underline',
            },
        },

        '@media (max-width: 600px)': {
            fontSize: `16px !important`,
            fontWeight: `300 !important`,
            lineHeight: '21px',
            padding: '0px 55px 10px 49px',
            letterSpacing: '0.33px',
            marginTop: 0,

            '& a': {
                fontSize: 16,
            },

            '& p': {
                marginTop: 0,
                marginBottom: 5,
                color: `${theme.colors.white} !important`,
                fontSize: `16px !important`,
                fontWeight: `300 !important`,
                lineHeight: '21px',
            },
        },
    },
    tick: {
        marginLeft: 20,
    },
    buttonDisabled: {
        backgroundColor: theme.colors.pinkishGrey,
        pointerEvents: 'none',
        '& button': {
            backgroundColor: theme.colors.pinkishGrey,
        },
        '& p': {
            color: `${theme.colors.warmGreyTwo} !important`,
        },
        '& path': {
            fill: `${theme.colors.warmGreyTwo} !important`,
        },
    },
    chevronWrapper: {},
}))

function Accordion(props) {
    const { open, disabled, toggleOpen, completed, booking } = props
    const [active, setActiveState] = useState(false)
    const [setHeight, setHeightState] = useState('0px')

    const content = useRef(null)

    const classes = useStyles()

    if (props.booking === true) {
        const accordionClasses = open ? classes.accordionActive : classes.accordion
        const iconClasses = open ? classes.iconActive : classes.icon
        const activeHeight = !open ? '0px' : 'initial'

        // if(props.open === true) {
        //   setActiveState(true);
        //   toggleAccordion();
        // }

        const disabledClasses = props.disabled === true ? classes.buttonDisabled : null

        return (
            <div className={`${classes.main} ${disabledClasses}`}>
                <button className={accordionClasses} onClick={() => props.toggleOpen()}>
                    <p className={classes.title}>{props.title}</p>
                    <div className={`${classes.chevronWrapper} ${iconClasses}`}>
                        <SVG name={'Chevron'} width={30} height={18} colorOne={'#F6C413'} />
                    </div>
                    {props.completed === true && props.disabled !== true && (
                        <div className={classes.tick}>
                            <SVG
                                name={'TickCircle'}
                                width={30}
                                height={30}
                                colorOne={'#01396c'}
                                colorTwo={'#FFFFFF'}
                            />
                        </div>
                    )}
                </button>
                <div
                    ref={content}
                    style={{ maxHeight: `${activeHeight}` }}
                    className={classes.content}
                >
                    <div className={classes.text}>{props.children}</div>
                </div>
            </div>
        )
    }

    function toggleAccordion() {
        setActiveState(!active)
        setHeightState(active ? '0px' : `${content.current.scrollHeight}px`)
    }

    const accordionClasses = active ? classes.accordionActive : classes.accordion
    const iconClasses = active ? classes.iconActive : classes.icon

    return (
        <div className={classes.main}>
            <button className={accordionClasses} onClick={toggleAccordion}>
                <p className={classes.title}>{props.title}</p>
                <div className={`${classes.chevronWrapper} ${iconClasses}`}>
                    <SVG name={'Chevron'} width={30} height={18} colorOne={'#F6C413'} />
                </div>
            </button>
            <div ref={content} style={{ maxHeight: `${setHeight}` }} className={classes.content}>
                <div className={classes.text}>{props.children}</div>
            </div>
        </div>
    )
}

export default Accordion
